import { Box } from '@mui/material';
import SupplyChain from '../../../supply-chain/components/SupplyChain';
import { ArtifactInfo } from '../../types/artifacts-type';
import ArtifactCloudData from './ArtifactCloudData';
import ArtifactCodeInfo from './ArtifactCodeInfo';
import ArtifactGeneralInfo from './ArtifactGeneralInfo';
import ArtifactPipelineDefinition from './ArtifactPipelineDefinition';
import ArtifactPipelineExecutionInfo from './ArtifactPipelineExecutionInfo';
import ArtifactRegistryInfo from './ArtifactRegistryInfo';

export const tabs: TabConfig<ArtifactInfo>[] = [
  {
    name: 'Overview',
    shouldShow: artifact =>
      !!artifact.supplyChainInfo && !!artifact.artifactInfo,
    Component: ({ artifact, classes }) => {
      return (
        <>
          {artifact && artifact.supplyChainInfo && (
            <div className={classes.supplyChainSection}>
              <SupplyChain
                items={artifact.supplyChainItems}
                haveCoverage={false}
              />
            </div>
          )}
          {artifact && artifact.artifactInfo && (
            <Box mt={2}>
              <ArtifactGeneralInfo artifact={artifact} />
            </Box>
          )}
        </>
      );
    },
  },
  {
    name: 'Code',
    shouldShow: artifact => !!artifact.codeDescription,
    infoIconTooltip:
      'Code card describes the changes, that created this artifact.',
    Component: ({ artifact }) => <ArtifactCodeInfo artifact={artifact} />,
  },
  {
    name: 'CI/CD',
    shouldShow: artifact =>
      !!artifact.cicdDescription?.pipelineExecution ||
      !!artifact.cicdDescription?.pipeline,
    infoIconTooltip:
      'This card describes the pipeline that created the artifact, and also general information about this pipeline',
    Component: ({ artifact }) => (
      <>
        <ArtifactPipelineExecutionInfo artifact={artifact} />
        <ArtifactPipelineDefinition artifact={artifact} />
      </>
    ),
  },
  {
    name: 'Registry',
    shouldShow: artifact => artifact.registryDescription.length > 0,
    infoIconTooltip:
      'The physical location of the artifact, such as cloud server on Amazon, Jfrog or Google',
    Component: ({ artifact }) => (
      <>
        {(artifact.registryDescription || []).map((registry, index) => {
          return (
            <ArtifactRegistryInfo
              key={index}
              artifact={artifact}
              registry={registry}
            />
          );
        })}
      </>
    ),
  },
  {
    name: 'Cloud',
    shouldShow: artifact => artifact.cloudData?.length > 0,
    infoIconTooltip:
      'Describes the general information on the artifact running environment, such as zone, user, and also runtime information',
    Component: ({ artifact }) => (
      <>
        {(artifact.cloudData || []).map(cloud => {
          return <ArtifactCloudData artifact={artifact} cloud={cloud} />;
        })}
      </>
    ),
  },
];

interface TabConfig<Entity> {
  name: string;
  infoIconTooltip?: string;
  Component: TabContentComponent;
  shouldShow(item: Entity): boolean;
}

type TabContentComponent = (props: {
  artifact: ArtifactInfo;
  classes: {
    supplyChainSection: string;
  };
}) => JSX.Element;
